import { render, staticRenderFns } from "./departamentos.vue?vue&type=template&id=67924dd1"
import script from "./departamentos.vue?vue&type=script&lang=js"
export * from "./departamentos.vue?vue&type=script&lang=js"
import style0 from "./departamentos.vue?vue&type=style&index=0&id=67924dd1&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports